export default __webpack_public_path__ + "static/media/james-timothy.8046d531.jpg";